import Box from "@/components/Box";
import { ExternalTextLink } from "@/components/Links";
import Stack from "@/tpo/Stack";
import ButtonV2 from "@/v2/Buttons";

const EVENTBRITE_URL =
  "https://www.eventbrite.co.uk/e/clinical-principles-for-autoimmunity-management-tickets-1994576731697";

export default function ClinicalPrinciplesAutoimmunityPromo({ onClose, setShowNotification }) {
  return (
    <Box px={[20, 20, 40]} pb={80}>
      <Stack alignItems="center" gap={0} maxWidth={760} stacked mx="auto">
        <Box
          as="h2"
          fontFamily="gilroyBold"
          fontSize={[28, 28, 44]}
          lineHeight="150%"
          textAlign="center"
        >
          Final Week - Book Now!
        </Box>
        <Box
          fontFamily="gilroyRegular"
          fontSize={[16, 16, 18]}
          lineHeight="150%"
          pt={[20, 20, 40]}
          textAlign="center"
        >
          Don&apos;t miss out: grab your tickets for our Clinical Principles for Autoimmunity Event
          now!
        </Box>
        <ButtonV2
          as={ExternalTextLink}
          href={EVENTBRITE_URL}
          underline={false}
          color="green"
          withChevron
          size={["sm", "sm", "md"]}
          mt={[20, 20, 40]}
          onClick={onClose}
          mx="auto"
        >
          Book now
        </ButtonV2>
        <ExternalTextLink
          onClick={e => {
            e.preventDefault();
            setShowNotification(false);
            onClose();
          }}
          mt={[20, 20, 40]}
          mx="auto"
          style={{ cursor: "pointer" }}
        >
          Don&apos;t show me this again
        </ExternalTextLink>
      </Stack>
    </Box>
  );
}
